import { Module } from "@/constants";
import { getDictionaryConfig } from "@/containers/dictionaries/getDictionaryConfig";
import { ReadStoreGroup, WriteStoreGroup } from "@/types/storeGroup";

export const useStoreGroupDictionary = () => {
  const config = getDictionaryConfig<ReadStoreGroup, WriteStoreGroup>(
    Module.StoreGroups,
  );
  return config;
};
